module.exports = __webpack_public_path__ + "img/certificate_221346006_00.d64501a9.jpg";